










import {Component, Prop, Vue} from 'vue-property-decorator'

import {designStore} from "@/store/store";
import BaseTraffic from "@/modules/design/views/BaseTraffic.vue";
import {IAcOverlayDesignImperial, IAcOverlayDesignMetric} from "@/modules/design/interfaces/acOverlay";
import {Route} from "vue-router";
import {minValue, required} from "vuelidate/lib/validators";
import {createAcOverlayValidations} from "@/modules/design/lib/validations/acOverlay";


@Component({
  components: {
    BaseTraffic
  },
})
export default class AcOverlayTraffic extends Vue {
  @Prop() readonly pxDesignId!: string;
  @Prop() readonly page!: number;


  get scenario(): IAcOverlayDesignImperial | IAcOverlayDesignMetric {
    return designStore.currentAcOverlay;
  }

  get scenarioImperial(){
    return designStore.currentAcOverlayImperial
  }

  validations() {
    return createAcOverlayValidations(this.scenarioImperial)
  }

  save(){
    this.sync();
    designStore.saveCurrentAcOverlayScenario()
  }

  sync() {
    designStore.setCurrentAcOverlayScenario(this.scenario)
  }

  get numLayers() {
    // Required for validating whether the user has created any layers.
    return this.scenarioImperial.existingLayers.length;
  }

  beforeRouteLeave(to: Route, from: Route, next:Function){
    this.save();
    next()
  }

}

